
export const TOOLBAR_COMPONENT_ID = 'ToolbarComponent';
